const currencySuffix = {
  BRL: '',
  PEN: '',
  COP: 'COP',
  USD: 'USD',
} as const;

export { currencySuffix };
